import React from "react";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import { Button, makeStyles } from "@material-ui/core";

const style = {
  fontStyle: "bold",
};

const useStyles = makeStyles({
  compactCell: {
    padding: "4px 4px",
    lineHeight: 1.2,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  compactCellSticky: {
    padding: "0px 10px",
    margin: "0px",
    lineHeight: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    position: "sticky",
    left: 0,
    backgroundColor: "#ffffff",
    borderRight: "2px solid red",
    zIndex: 1000,
  },
});

const TitleResultReport = ({ data, controles, controlesArray }) => {
  // data.reportType === 5 -> esta fila (corte de título) es de una
  // subclasificación — ya viene con nombreSubclasificacion desde
  // ImprimirDatos (reportsLogic.jsx). Se detecta por fila, no por un prop de
  // toda la tabla, porque el tab Ganadores mezcla filas normales (reportType
  // 4) con filas de ganadores de subclasificación (reportType 5).
  const esSubclasificacion = data.reportType === 5;
  const classes = useStyles();
  var controlesText;
  if (controles) {
    if (controlesArray["modalidad_" + data.codMod] != undefined) {
      const arrayTitles = controlesArray["modalidad_" + data.codMod].titles;
      console.log("arrayTitles", arrayTitles);
      controlesText = arrayTitles
        .sort((a, b) => a.kilometro - b.kilometro)
        .map((title, index) => (
          <TableCell align="center" className={classes.compactCell} style={style} key={index + " " + data.mod}>
            {title.descripcionPunto}
            <br />
            <span className="small-text">km: {title.kilometro}</span>
          </TableCell>
        ));
    }
  }

  const defaultTitle = (
    <TableRow align="center">
      <TableCell align="center" className={classes.compactCellSticky} style={style}>Núm</TableCell>
      <TableCell align="center" className={classes.compactCell} style={style}>Lugar General</TableCell>
      <TableCell align="center" className={classes.compactCell} style={style}>Lugar Rama</TableCell>
      <TableCell align="center" className={classes.compactCell} style={style}>
        {esSubclasificacion ? data.nombreSubclasificacion || "Subclasificación" : "Lugar Categoría"}
      </TableCell>
      <TableCell align="center" component="th"  scope="row">
        Nombre
      </TableCell>
      <TableCell align="center" className={classes.compactCell} style={style}>Género</TableCell>
      <TableCell align="center" className={classes.compactCell} style={style}>Categoría</TableCell>
      <TableCell align="center" className={classes.compactCell} style={style}>Modalidad</TableCell>
      {controlesText}
      <TableCell align="center" className={classes.compactCell} style={style}>Tiempo Oficial</TableCell>
      <TableCell align="center" className={classes.compactCell} style={style}>Tiempo Real</TableCell>
    </TableRow>
  );

  return defaultTitle;
};

export default TitleResultReport;
